import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
} from '@ant-design/icons';
import { Controller, TextAreaController } from '@organisms';
import { Space } from 'antd';
import { useMemo } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';

import { MaskedInputController } from 'src/app/framework/organisms/Controllers/MaskedInputController.organism';
import { cnpjMask } from 'src/constants/masks';
import { TenantFormData } from 'src/features/tenants/types/tenantForm.types';

import { TenantFormSection } from '../formSection.types';

export const InitialDataForm: TenantFormSection = ({
  isEditing,
  isLoadingEditData,
  isLoadingFields,
}) => {
  const { control, watch } = useFormContext<TenantFormData>();
  const { errors } = useFormState<TenantFormData>();

  const tenantAlias = watch('initialData.tenantAliasId');
  const isTenantAliasIdExistsError = useMemo(
    () =>
      !isEditing &&
      errors.initialData?.['tenantAliasId']?.type === 'tenant-alias-exists',
    [isEditing, errors.initialData?.['tenantAliasId'], tenantAlias]
  );

  return (
    <Space direction='vertical' size='small' style={{ width: '100%' }}>
      <Controller
        label='Nome fantasia'
        name='initialData.fantasyName'
        placeholder='Digite aqui...'
        control={control}
        disabled={isLoadingEditData}
        required
      />
      <Controller
        label='Razão social'
        name='initialData.socialName'
        placeholder='Digite aqui...'
        control={control}
        disabled={isLoadingEditData}
        required
      />
      <MaskedInputController
        label='CNPJ'
        mask={[cnpjMask]}
        name='initialData.document'
        placeholder='Digite aqui...'
        control={control}
        disabled={isLoadingEditData}
        required
      />
      <Controller
        label='Tenant Alias'
        name='initialData.tenantAliasId'
        placeholder='Digite aqui...'
        control={control}
        disabled={isEditing}
        required
        suffix={
          <>
            {isLoadingFields.initialData.tenantAliasId && <LoadingOutlined />}
            {!isLoadingFields.initialData.tenantAliasId &&
              isTenantAliasIdExistsError && (
                <CloseCircleFilled style={{ color: 'red' }} />
              )}
            {!isLoadingFields.initialData.tenantAliasId &&
              !isTenantAliasIdExistsError &&
              tenantAlias?.length > 2 && (
                <CheckCircleFilled style={{ color: '#49aa19' }} />
              )}
          </>
        }
      />
      <TextAreaController
        label='Descrição'
        name='initialData.description'
        placeholder='Descreva aqui...'
        row={4}
        control={control}
        disabled={isLoadingEditData}
      />
    </Space>
  );
};
